import { ActionCreator } from 'redux'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { NotificationApi } from '../../../api/notificationApi'
import { toastMsg } from '../../../components/Toast/toastMsg'
import { NotificationState } from '../reducers'
import { INotificationData } from '../types/notification'
import * as constants from './constants'


export type NotificationsThunkResult<R> = ThunkAction<Promise<R>, NotificationState, null, NotificationsActions>
export type NotificationsThunkDispatchType = ThunkDispatch<NotificationState, null, NotificationsActions>

export interface NotificationsHasErrored {
  type: constants.NOTIFICATION_HAS_ERRORED
  hasErrored: boolean
}

export interface GetNotificationsSuccess {
  type: constants.GET_NOTIFICATIONS_SUCCESS
  notifications: INotificationData[]
}

export interface UpdateNotificationsSuccess {
  type: constants.UPDATE_NOTIFICATION_SUCCESS
  data: number[]
}

export interface DeleteNotificationsSuccess {
  type: constants.DELETE_NOTIFICATION_SUCCESS
  notification: INotificationData
}

export const notificationHasErrored = (hasErrored: boolean, error: Error, action?: string): NotificationsHasErrored => {
  if (error && action) {
    const errorMsg = error.message
    if (errorMsg !== 'Authentication credentials were not provided.') {
      toastMsg(errorMsg, action, 'error')
    }
  }
  return {
    type: constants.NOTIFICATION_HAS_ERRORED,
    hasErrored: hasErrored
  }
}

export const getNotifications: ActionCreator<NotificationsThunkResult<INotificationData[]>>
= (queryParams?: Record<string, string>): NotificationsThunkResult<INotificationData[]> => {
  return async (dispatch: NotificationsThunkDispatchType) => {
    return NotificationApi.getNotifications(queryParams)
      .then(response => {
        dispatch(getNotificationsSuccess(response))
        return response
      })
      .catch(error => {
        dispatch(notificationHasErrored(true, error.response.data, constants.GET_NOTIFICATIONS))
        return {} as INotificationData[]
      })
  }
}

export const getNotificationsSuccess = (notifications: INotificationData[]): GetNotificationsSuccess => {
  return {
    type: constants.GET_NOTIFICATIONS_SUCCESS,
    notifications
  }
}

export const updateNotification: ActionCreator<NotificationsThunkResult<number[]>>
= (employee_id: number, notificationsIds: number[]): NotificationsThunkResult<number[]> => {
  return async (dispatch: NotificationsThunkDispatchType) => {
    return NotificationApi.updateNotification(employee_id, notificationsIds)
      .then(response => {
        dispatch(updateNotificationSuccess(response))
        return response
      })
      .catch(error => {
        dispatch(notificationHasErrored(true, error.response.data, constants.UPDATE_NOTIFICATION))
        return []
      })
  }
}

export const updateNotificationSuccess = (data: number[]): UpdateNotificationsSuccess => {
  return {
    type: constants.UPDATE_NOTIFICATION_SUCCESS,
    data
  }
}

export const deleteNotification: ActionCreator<NotificationsThunkResult<string | number | void>>
= (notification: INotificationData): NotificationsThunkResult<string | number | void> => {
  return async (dispatch: NotificationsThunkDispatchType) => {
    return NotificationApi.deleteNotification(notification)
      .then(response => {
        dispatch(deleteNotificationSuccess(notification))
        return response
      })
      .catch(error => {
        dispatch(notificationHasErrored(true, error.response.data, constants.DELETE_NOTIFICATION))
      })
  }
}

export const deleteNotificationSuccess = (notification: INotificationData): DeleteNotificationsSuccess => {
  toastMsg(`Deleted ${notification.title} notification successfully.`, constants.DELETE_NOTIFICATION_SUCCESS, 'success')
  return {
    type: constants.DELETE_NOTIFICATION_SUCCESS,
    notification
  }
}

export type NotificationsActions
  = GetNotificationsSuccess
  | UpdateNotificationsSuccess
  | DeleteNotificationsSuccess
  | NotificationsHasErrored
